import * as React from "react";
import { merge, $, media } from "glamor";
import { theme } from "styles/theme";

interface IProps {
    totalUnitsLabel: string;
    totalUnitsValue: number;
    totalRetailLabel: string;
    totalRetailValue: string;
    totalCostLabel: string;
    totalCostValue: string;
}

export const Totals: React.FunctionComponent<IProps> = ({
    totalUnitsLabel,
    totalUnitsValue,
    totalRetailLabel,
    totalRetailValue,
    totalCostLabel,
    totalCostValue,
}) => {
    const styles = React.useMemo(() => {
        return merge(
            {
                width: "100%",
                maxWidth: "296px",
                borderRadius: "8px",
                backgroundColor: "#f5f5f5",
                display: "flex",
                position: "absolute",
                right: "0px",
                padding: "10px 16px",
            },
            $(" .totalAmount, .totalQuantity", {
                flex: 1,
                color: theme.palette.darkestGrey,
            }),
            $(" .totalsLabel", {
                fontSize: "12px",
                whiteSpace: "nowrap",
            }),
            $(" .price", {
                fontWeight: "bold",
                paddingBottom: "8px",
            }),
            $(" .totalAmount div", {
                textAlign: "right",
            }),
            media("(max-width: 940px)", {
                maxWidth: "100%",
                position: "relative",
                marginTop: "8px",
            })
        );
    }, []);

    // dont show if we have nothing
    if (!totalUnitsLabel && !totalCostLabel && !totalRetailLabel) {
        return null;
    }

    return (
        <div {...styles}>
            <div className="totalQuantity">
                {totalUnitsLabel && (
                    <React.Fragment>
                        <div className="totalsLabel">{totalUnitsLabel}</div>
                        <div className="price">{totalUnitsValue}</div>
                    </React.Fragment>
                )}
            </div>
            <div className="totalAmount">
                {totalCostLabel && (
                    <React.Fragment>
                        <div className="totalsLabel">{totalCostLabel}</div>
                        <div className="price">{totalCostValue}</div>
                    </React.Fragment>
                )}
                {totalRetailLabel && (
                    <React.Fragment>
                        <div className="totalsLabel">{totalRetailLabel}</div>
                        <div className="price">{totalRetailValue}</div>
                    </React.Fragment>
                )}
            </div>
        </div>
    );
};
